import { gql } from '@apollo/client';

interface UnavailableItem {
  uid: string;
  reasons: string[];
}

interface UnavailabilityInfo {
  unavailableProducts: UnavailableItem[];
}

interface UnavailabilityData {
  data: UnavailabilityInfo;
}

interface UnavailabilityResult {
  result: UnavailabilityData;
}

export interface CHECK_FOR_UNAVAILABLE_PRODUCTS_TYPE {
  wIsCartHasUnavailableProducts: UnavailabilityResult;
}

export const CHECK_FOR_UNAVAILABLE_PRODUCTS = gql`
  query wIsCartHasUnavailableProducts($cartId: String!, $country: String!) {
    wIsCartHasUnavailableProducts(cartId: $cartId, country: $country)
  }
`;
